import React from "react";
import Icon from "@ant-design/icons";
import mailIcon from "../../../assets/Svg/mail.png";
const MailSvg = () => <img src={mailIcon} alt="" />;

const MailIcon = (props) => <Icon component={MailSvg} {...props} />;

export default MailIcon;
